import * as React from 'react';
import {Button, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteConfirm = ({ openDelete, handleClose, handleDelete }) => {

    return (
        <React.Fragment>

            <Dialog
                open={openDelete}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle className='modal_header_dealog' >{"Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" className='text-center'>
                        
                    <IconButton aria-label="delete" color="error" size="large">
                            <DeleteIcon fontSize="inherit" />
                        </IconButton><br/>
                        Are you sure you want to delete this item?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="outlined">Cancel</Button>
                    <Button color="error" variant="outlined" onClick={handleDelete}> 
                    
                        Confirm</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default DeleteConfirm